import { render } from "./ResponsePage.vue?vue&type=template&id=7fc3cd9e&scoped=true"
import script from "./ResponsePage.vue?vue&type=script&lang=js"
export * from "./ResponsePage.vue?vue&type=script&lang=js"

import "./ResponsePage.vue?vue&type=style&index=0&id=7fc3cd9e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fc3cd9e"]])

export default __exports__